import { lazy } from 'react';

const RELOAD_KEY = 'devalpha_chunk_reload';

const reloadOnce = () => {
  const hasReloaded = sessionStorage.getItem(RELOAD_KEY);
  if (!hasReloaded) {
    sessionStorage.setItem(RELOAD_KEY, '1');
    window.location.reload();
  }
};

export const lazyWithRetry = (
  factory: () => Promise<{ default: React.ComponentType<object> }>
) =>
  lazy(() =>
    factory().catch((error: Error) => {
      if (
        error?.name === 'ChunkLoadError' ||
        error?.message?.includes('Loading chunk') ||
        error?.message?.includes('Failed to fetch')
      ) {
        reloadOnce();
      }
      throw error;
    })
  );

export const clearChunkReloadFlag = () => {
  sessionStorage.removeItem(RELOAD_KEY);
};
